export default __webpack_public_path__ + "static/media/video-link.ceaa77f6.svg";